import { React, useState, useEffect,useRef  } from "react";
import { Link } from "react-router-dom";
import apibig from "../../../components/Apibig"; // Importa la configuración de Axios
import {useProyectos} from '../../../hooks/useProyectos'
import Restriccion from "../../../components/Restriccion";
import { MdEventNote } from "react-icons/md";
import { IoSettingsOutline, IoTrash, IoCloseSharp } from "react-icons/io5";
import { FaChevronDown, FaRoute, FaEdit } from "react-icons/fa";
import { 
  MdOutlineArrowDropUp,
  MdOutlineArrowDropDown,
  MdOutlineArrowLeft  ,
  MdOutlineArrowRight} from "react-icons/md";
import loadingicon from "./loading.png";
import {
  LuChevronsLeft,
  LuChevronsRight,
  LuChevronLeft,
  LuChevronRight,
} from "react-icons/lu";

const icons = {
  carretro: FaRoute,
  chevrondown: FaChevronDown,
  config: IoSettingsOutline,
  siniestralidad: MdEventNote,
  tabant: LuChevronLeft,
  tabsig: LuChevronRight,
  tabinicio: LuChevronsLeft,
  tabfinal: LuChevronsRight,
  edit: FaEdit,
  trash: IoTrash,
  close: IoCloseSharp,
  arrowdown:MdOutlineArrowDropDown,
  arrowup:MdOutlineArrowDropUp ,
  arrowleft:MdOutlineArrowLeft,
  arrowrighght:MdOutlineArrowRight ,
};

// temporal
const usuariofirmado="JUAN CARLOS ARREOLA LOPEZ"


const initialForm = {
    id: "",
    nombreproyecto:"",

};
const validationsForm = (form) => {
  let errores = {}
  /* */
  let regexText=/^[A-ZazÑñÁáÉéIíÓóÚú\s]+$/;
  let regexNum=/^[0-9\b]+$/;
  let regexDate =/^(0?[1-9]|[12][0-9]|3[01])[\/\-\.](0?[1-9]|1[012])[\/\-\.](\d{4})$/;

/* validacion de siniestro */
  if (!form.nombreproyecto.trim()) {
  
    errores.nombreproyecto = "El campo proyecto esta vacio.";
  } else if(!regexText.test(form.nombreproyecto.trim())){
    errores.nombreproyecto = "El campo proyecto no puede contener espacios en blanco.";
  }

/* validacion de poliza 
  if (!form.poliza.trim()) {
    errores.poliza = "El campo póliza esta vacia.";
  }else if(!regexNum.test(form.poliza.trim())){
    errores.poliza = "El campo poliza no puede contener caracteres alfanumericos.";
  }
/* validacion de fecha */
/*
  if (!form.fechasiniestro.trim()) {
    errores.fechasiniestro = "El campo fecha de siniestro esta vacia.";
  }else if(!regexDate.test(form.fechasiniestro.trim())){
    errores.fechasiniestro = "El campo fecha de siniestro debe tener el fomato fecha YYYY/MM/DD.";
  }
  if (!form.fechareporte.trim()) {
    errores.fechareporte = "El campo fecha de reporte esta vacia.";
  }else if(!regexDate.test(form.fechasiniestro.trim())){
    errores.fechareporte = "El campo fecha de siniestro debe tener el fomato fecha YYYY/MM/DD.";
  } 
  if (!form.conductor.trim()) {
    errores.conductor = "El campo Conductor esta vacio.";
  }
  if (!form.nocaseta.trim()) {
    errores.nocaseta = "El campo Número de caseta esta vacio.";
  }else {
  }

 */
  return errores;
};
/* fin de control de formualrio proyectps*/
const Proyectos = ({ autusuario }) => {
  const [isopenpermisos,setIsoopenpermisos]=useState(false);
  //
  const [colorenable,setColorenable]=useState(true);
  const [dataproyectos, setDataproyectos] = useState([]);

 
  const [selectedOption, setSelectedOption] = useState("");
  const [cargando, setCargando] = useState(true);
  // 
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: "nombreproyecto", direction: "asc", });
  const itemsPerPage = 12;      // elementos por pagian¿
  const maxPageButtons = 10;    // Máximo de botones visibles
  const totalPages = Math.ceil(dataproyectos.length / itemsPerPage);

//
const {
  form,
  errores,
  loading,
  response,
  tabla,
  handleChange,
  handleBlur,
  handleSubmit,
  handleClear,
} = useProyectos(initialForm, validationsForm,autusuario,apibig,dataproyectos);

  const handleFormpermisos = () => {
    setIsoopenpermisos(!isopenpermisos);
    setColorenable(!colorenable);
  };
  const DynamicIcon = ({ iconName, color, size }) => {
    const IconComponent = icons[iconName];
    return IconComponent ? (
      <IconComponent className="text-[1em] mt-1" color={color} size={size} />
    ) : null;
  };
  const sortedData = [...dataproyectos].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  const currentData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Calcular el rango de botones visibles
  const startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
  const endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
  const visiblePages = Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
 

  useEffect(() => {  
    // Llamada de roles para select de usuarios
    const fetchproyectos = async () => {
      try {
        const proyecto = autusuario.configuracion.proyecto;
        const response = await apibig.post("/api/proyectos/getproyectos");
        setDataproyectos(response.data);       
      } catch (error) {
        console.error("Error al obtener proyectos:", error);
      } finally {
        setCargando(false);
      }
    };   
    // Inicializa el formulario desde la api 
    fetchproyectos();
  }, [dataproyectos]);
  //
  const handleChangeOption = (e) => {
    setSelectedOption(e.target.value); // Establecer la opción seleccionada
  };

  // Handle sort
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  }; 

  const permiso = true;
  if (!permiso) {
    return <Restriccion />;
  } else {
    return (
      <div className="w-full bg-white">
        <div
          className={`relative min-h-[100vh] mb-2 ${colorenable?"bg-gray-200":"bg-gray-400"} rounded-[1vw] m-2 gap-2`}
        >
          
          <div className="flex justify-between gap-2 px-4  bg-menusplash-100  rounded-md text-white font-bold items-center">
            <span className="w-full text-center text-[1.5rem]">Proyectos</span>
          </div>
          <form name="frmproyectos" onSubmit={handleSubmit}>
          <div className="w-full min-h-[24vh] pb-2 bg-white grid grid-cols-6 gap-4 mb-2 pt-[5vh] px-[2vw]">
            <div className="col-span-3 text-[1.5rem]   text-textFrom-100 flex flex-col">
              <label className="font-bold">Proyecto</label>
              <input  
              name="nombreproyecto"
              value={form.nombreproyecto}  
              onChange={handleChange} 
              placeholder="Escriba nombre de proyecto" 
              className="border border-1 rounded-md pl-4" />
            </div>
            <div className="col-span-2 text-[1.5rem] text-textFrom-100 flex flex-col">                                
            </div>
            <div className="col-span-1  text-[1.5rem] font-bold flex flex-col gap-3">
              <button className="h-[6vh] bg-btnSuccess-100 hover:bg-btnSuccess-200 rounded-md text-white">
                Agregar 
              </button>
              <button onClick={handleClear}
              className="h-[6vh] bg-btnCancelar-100 hover:bg-btnCancelar-200 rounded-md text-white">
                Cancelar
              </button>
            </div>
          </div></form>
          <div className="flex justify-center">
            <table className="w-[96%] border-spacing-0 round-md">
              <thead className="rounded-sm">
                <tr className="bg-encabTabla-100 h-[4vh] grid grid-cols-6  text-white">
                  <th
                    className="col-span-2 text-left px-5"
                    onClick={() => handleSort("nombreproyecto")}
                    style={{ cursor: "pointer" }}
                  >
                    Proyecto
                    {sortConfig.key === "nombreproyecto" &&
                      (sortConfig.direction === "asc" ? "▲" : "▼")}
                  </th>
 
                 
                  <th className="col-1 text-left px-5"></th>
                </tr>
              </thead>
              <tbody>
              
                {currentData.map((item) => (
                  <tr
                    key={item.Id}
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="col-span-2  px-2 text-left">
                      {item.NombreProyecto}
                    </td>
                    {/*<td className="col-1 px-2 flex gap-1">
                      <Link   onClick={() => {handleFormpermisos()}}><DynamicIcon iconName="edit" color="00337f" /></Link>
                    </td>*/}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Paginacion */}
          <div className="pt-1 top-[20px] text-center">
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageChange(1)}
              style={{
                marginRight: "5px",
                padding: "5px 10px",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <DynamicIcon iconName="tabinicio" size="1.5em" color="00337f" />
            </button>
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
              style={{
                marginRight: "5px",
                padding: "5px 10px",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <DynamicIcon iconName="tabant" size="1.5em" color="00337f" />
            </button>

            {visiblePages.map((page) => (
              <button
                key={page}
                className="mx-[5px] bg-red-300 rounded-[1vh]"
                style={{
                  padding: "5px 10px",
                  backgroundColor: currentPage === page ? "#007bff" : "#f8f9fa",
                  color: currentPage === page ? "#fff" : "#000",
                  border: "1px solid #dee2e6",
                  cursor: "pointer",
                }}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            ))}

            <button
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
              style={{
                marginLeft: "5px",
                padding: "1px 10px",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <DynamicIcon iconName="tabsig" size="1.5em" color="00337f" />
            </button>
            <button
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(totalPages)}
              style={{
                marginLeft: "5px",
                padding: "5px 10px",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <DynamicIcon iconName="tabfinal" size="1.5em" color="00337f" />
            </button>
          </div>
        </div>
        <div className="flex justify-center">
        <div
          id="permisosform"
          className={` ${isopenpermisos?"":"hidden"} relative -top-[97vh] min-w-[94%] min-h-[65vh] mb-2 ${colorenable?"bg-gray-200":"bg-gray-200"}  rounded-[1vw] m-[2.5vw] gap-2`}
        >
          {/* formulario permisos  html*/}          
          <div 
          className={`flex justify-between gap-2 px-4  bg-menusplash-200  rounded-md text-white font-bold items-center`}>
            <span className="w-full text-center text-[1.4rem]">Permisos <span className="text-[#00337f] text-[1.2rem]">{usuariofirmado}</span></span>
            <Link   onClick={() => {handleFormpermisos()}}><DynamicIcon iconName="close" size="1.5em" color="#fff" /></Link>
          </div>
          <div className="bg-white mx-5 mt-2 min-h-[15vh] rounded-md">
          <div className="w-full min-h-[18vh] grid grid-cols-4 gap-4 mb-2 pt-[5vh] px-[2vw]">
            <div className="col-span-3 text-[1rem] text-textFrom-100 flex flex-col">
              <label className="text-[1rem] font-bold">Nombre usuario: <span className="text-[1rem] text-[#fb6605]">JUAN CARLOS ARREOLA LOPEZ</span></label>             
              <label className="text-[1rem] font-bold">Email: <span className=" text-[1rem] text-[#fb6605]">carlos.arreola@fyfasesores.mx</span></label>
              <label className="text-[1rem] font-bold">Rol: <span className=" text-[1rem] text-[#fb6605]">ADMINISTRADOR</span></label>
           </div>
           <div className="col-span-1 text-[1rem] gap-2 text-textFrom-100 flex flex-col mb-4">
           <button  onClick={() => {handleFormpermisos()}} className="h-[6vh] bg-btnSuccess-100  hover:bg-btnSuccess-200 rounded-md text-white">
                Guardar
              </button>
              <button className="h-[6vh] bg-btnCancelar-100 hover:bg-btnCancelar-200 rounded-md text-white">
                Cancelar
              </button>
             </div>
           </div>
          </div>
          <div className=" min-h-[57vh]">
          <div className="flex justify-center ml-[4vh] w-[96%] rounded-md bg-white min-h-[47vh]">
            <table className="w-full border-spacing-0 round-md">
              <thead className="rounded-sm">
                <tr className="bg-encabTabla-100 h-[4vh] grid grid-cols-6  text-white rounded-t-md">
                  <th
                    className="col-span-2 gap-1 text-left px-5"
                    onClick={() => handleSort("nombreusuario")}
                    style={{ cursor: "pointer" }}
                  >
                    Modulo
                    {sortConfig.key === "nombreusuario" &&
                      (sortConfig.direction === "asc" ? " ▲ " : " ▼ ")}
                  </th>
                 
                  <th
                    className="col-span-1 text-left px-5"
                    onClick={() => handleSort("email")}
                    style={{ cursor: "pointer" }}
                  >
                    Permiso
                    {sortConfig.key === "email" &&
                      (sortConfig.direction === "asc" ? " ▲ " : " ▼ ")}
                  </th>
                  
                  <th className="col-1 text-left px-5"></th>
                </tr>
              </thead>
              <tbody className="text-[#00337f] font-bold">               
                  <tr                    
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="flex col-span-2 gap-2 px-2 text-left"><DynamicIcon iconName="tabsig" color="00337f" />    
                      <span>Siniestralidad </span>               
                    </td>                    
                    <td className="col-1 text-center px-2 ">
                    <select>
                      <option>SI</option>
                      <option>NO</option></select>
                    </td>
                    
                  </tr>
                  <tr
                    
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="flex col-span-2 gap-2 px-2 text-left"><DynamicIcon iconName="tabsig" color="fff" />    
                      <span>Cotizador </span>               
                    </td>                    
                    <td className="col-1 text-center px-2 ">
                    <select>
                      <option>SI</option>
                      <option>NO</option></select>
                    </td>
                    
                  </tr>
                  <tr
                    
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="flex col-span-2 gap-2 px-2 text-left"><DynamicIcon iconName="tabsig" color="00337f" />    
                      <span>Control de facturas </span>               
                    </td>                    
                    <td className="col-1 text-center px-2 ">
                    <select>
                      <option>SI</option>
                      <option>NO</option></select>
                    </td>
                    
                  </tr>
                  <tr
                    
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="flex col-span-2 gap-2 px-2 text-left"><DynamicIcon iconName="tabsig" color="fff" />    
                      <span>Control carretero </span>               
                    </td>                    
                    <td className="col-1 text-center px-2 ">
                    <select>
                      <option>SI</option>
                      <option>NO</option></select>
                    </td>
                    
                  </tr>
                  <tr
                    
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="flex col-span-2 gap-2 px-2 text-left"><DynamicIcon iconName="tabsig" color="00337f" />    
                      <span>Control de pagos </span>               
                    </td>                    
                    <td className="col-1 text-center px-2 ">
                    <select>
                      <option>SI</option>
                      <option>NO</option></select>
                    </td>
                    
                  </tr>
                  <tr
                    
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="flex col-span-2 gap-2 px-2 text-left"><DynamicIcon iconName="tabsig" color="00337f" />    
                      <span>Estadísticas</span>               
                    </td>                    
                    <td className="col-1 text-center px-2 ">
                    <select>
                      <option>SI</option>
                      <option>NO</option></select>
                    </td>
                    
                  </tr>
                  <tr
                    
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="flex col-span-2 gap-2 px-2 text-left"><DynamicIcon iconName="tabsig" color="00337f" />    
                      <span>Control de obra </span>               
                    </td>                    
                    <td className="col-1 text-center px-2 ">
                    <select>
                      <option>SI</option>
                      <option>NO</option></select>
                    </td>                    
                  </tr>
                  <tr
                    
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="flex col-span-2 gap-2 px-2 text-left"><DynamicIcon iconName="tabsig" color="00337f" />    
                      <span>Configuración</span>               
                    </td>                    
                    <td className="col-1 text-center px-2 ">
                    <select>
                      <option>SI</option>
                      <option>NO</option></select>
                    </td>
                    
                  </tr>
                  <tr
                    
                    className="grid grid-cols-6  bg-white h-[4vh]  text-[1rem]"
                  >
                    <td className="flex col-span-2 gap-2 px-2 text-left"><DynamicIcon iconName="tabsig" color="00337f" />    
                      <span>Whatsaap</span>               
                    </td>                    
                    <td className="col-1 text-center px-2 ">
                    <select>
                      <option>SI</option>
                      <option>NO</option></select>
                    </td>
                    
                  </tr>
               
              </tbody>
            </table>
          </div>
               {/* Paginacion */}
               <div className="pt-1 top-[20px] text-center">
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageChange(1)}
              style={{
                marginRight: "5px",
                padding: "5px 10px",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <DynamicIcon iconName="tabinicio" size="1.5em" color="00337f" />
            </button>
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
              style={{
                marginRight: "5px",
                padding: "5px 10px",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <DynamicIcon iconName="tabant" size="1.5em" color="00337f" />
            </button>

            {visiblePages.map((page) => (
              <button
                key={page}
                className="mx-[5px] bg-red-300 rounded-[1vh]"
                style={{
                  padding: "5px 10px",
                  backgroundColor: currentPage === page ? "#007bff" : "#f8f9fa",
                  color: currentPage === page ? "#fff" : "#000",
                  border: "1px solid #dee2e6",
                  cursor: "pointer",
                }}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            ))}

            <button
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
              style={{
                marginLeft: "5px",
                padding: "1px 10px",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <DynamicIcon iconName="tabsig" size="1.5em" color="00337f" />
            </button>
            <button
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(totalPages)}
              style={{
                marginLeft: "5px",
                padding: "5px 10px",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <DynamicIcon iconName="tabfinal" size="1.5em" color="00337f" />
            </button>
          </div>
          </div>
        </div></div>
      </div>
    );
  }
};
export default Proyectos;
